export default "__VITE_ASSET__CzZwSz4s__"